import { render, staticRenderFns } from "./taskComponent.vue?vue&type=template&id=888787ce&scoped=true"
import script from "./taskComponent.vue?vue&type=script&lang=js"
export * from "./taskComponent.vue?vue&type=script&lang=js"
import style0 from "./taskComponent.vue?vue&type=style&index=0&id=888787ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888787ce",
  null
  
)

export default component.exports